/**
 * Thin analytics wrapper. Connects to window.analytics (Segment-compatible)
 * and window.gtag (Google Analytics) when available; logs to console in
 * development; fails silently otherwise.
 *
 * Replace/extend once the analytics schema is confirmed with the team (GPDS-894).
 */

// GA4 event names only allow letters/numbers/underscores and must start with a letter
function toGaEventName(name) {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .slice(0, 40);
}

// GA4 reporting expects snake_case parameter names (e.g. sessionId -> session_id)
function toGaParams(properties) {
  return Object.fromEntries(
    Object.entries(properties).map(([key, value]) => [
      key.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`),
      value,
    ])
  );
}

function track(eventName, properties = {}) {
  try {
    if (
      typeof window !== "undefined" &&
      typeof window.analytics?.track === "function"
    ) {
      window.analytics.track(eventName, properties);
    } else if (process.env.NODE_ENV !== "production") {
      console.debug("[Analytics]", eventName, properties); // eslint-disable-line no-console
    }
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", toGaEventName(eventName), toGaParams(properties));
    }
  } catch (_) {
    // analytics must never surface errors to users
  }
}

export const analytics = { track };

// ─── Event name constants ─────────────────────────────────────────────────────
// Confirm these names with the team before instr umentation goes live.
export const PANEL_EVENTS = {
  PANEL_VIEWED: "Coach Connect — Panel Viewed",
  TAB_SWITCHED: "Coach Connect — Tab Switched",
  BOOKING_CTA_CLICKED: "Coach Connect — Booking CTA Clicked",
  RESCHEDULE_CTA_CLICKED: "Coach Connect — Reschedule CTA Clicked",
  NEXT_STEP_CTA_CLICKED: "Coach Connect — Next Step CTA Clicked",
  EVENT_LINK_CLICKED: "Coach Connect — Upcoming Event Clicked",
  OD15_CTA_CLICKED: "Coach Connect — OD15 CTA Clicked",
};
